import { render, staticRenderFns } from "./clinicItem.vue?vue&type=template&id=35a8a9ae&scoped=true&"
import script from "./clinicItem.vue?vue&type=script&lang=js&"
export * from "./clinicItem.vue?vue&type=script&lang=js&"
import style0 from "./clinicItem.vue?vue&type=style&index=0&id=35a8a9ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a8a9ae",
  null
  
)

export default component.exports